const termsMd = `
# Általános Szerződési Feltételek  
A jelen Általános Szerződési Feltételek (a továbbiakban: "ÁSZF") a Balaton 
Tánc Egyesület (továbbiakban: "Szolgáltató") által üzemeltetett 
https://www.balatonte.hu/ (továbbiakban: "Honlap") felhasználásával nyújtott 
támogatásokkal kapcsolatos jogokat és kötelezettségeket tartalmazza.

Jelen ÁSZF minden olyan támogatásra vonatkozik, amelyet az Ügyfél a 
Honlapon keresztül nyújt a Szolgáltató részére.

## 1. Szolgáltató adatai
- **Név:** Balaton Tánc Egyesület  
- **Székhely:** 8600 Siófok, Szépvölgyi u. 2.  
- **Nyilvántartási szám:** 14-02-0000570  
- **Adószám:** 19192716-1-14  
- **E-mail:** info@balatonte.hu  
- **Telefonos elérhetőség:** +36-20-446-6534
- **Nyilvántartásba vevő hatóság:** Kaposvári Törvényszék

## 2. A támogatás jellege
2.1. A Szolgáltató a Honlapon lehetőséget biztosít az Ügyfelek részére, hogy 
önkéntes anyagi támogatással hozzájáruljanak a Balaton Tánc Egyesület 
működéséhez.

2.2. A támogatás nem minősül jegyvásárlásnak vagy szolgáltatás vásárlásának. A 
támogatás nem jár ellenszolgáltatással.

2.3. A támogatás önkéntes és nem visszatérítendő.

## 3. Fizetési feltételek
3.1. Az Ügyfél a támogatás összegét a Honlapon feltüntetett módokon fizetheti 
meg. A fizetés Barion rendszerén keresztül történik.

3.2. A bankkártyás fizetések a Barion Payment Zrt. rendszerén keresztül 
történnek. A Barion rendelkezik a Magyar Nemzeti Bank engedélyével 
(engedélyszám: H-EN-I-1064/2013). A fizetés során megadott bankkártya 
adatok a Szolgáltatóhoz nem jutnak el.

3.3. A támogatásról a Szolgáltató a fizetést követően automatikusan elektronikus 
bizonylatot állít ki az Ügyfél által megadott e-mail címre.

## 4. Ismétlődő fizetés feltételei
4.1. A Felhasználó a fizetés befejezésével engedélyezi az automatikus havi 
terhelést.

4.2. A terhelés összege a választott csomag szerint 1 000 / 2 500 / 5 000 Ft.

4.3. A támogatási összeg változtatásához a meglévő előfizetést le kell mondani, 
majd új csomagot választani.

## 5. Lemondás
5.1. A támogatás bármikor, indoklás nélkül megszüntethető az 
e‑mailben kapott "Lemondás" linkkel vagy e‑mailben (info@balatonte.hu).

5.2. Lemondás azonnali, a folyó hónapban már banki terhelés történt, 
visszatérítés nem jár.

## 6. Elállás és visszatérítés
6.1. Mivel a támogatás nem termék‑ vagy szolgáltatásvásárlás, a 
45/2014. (II. 26.) Korm. rendelet elállási szabálya nem alkalmazandó.

6.2. A megrendelés elküldésével az Ügyfél lemond a 14 napos elállási jogáról az 
elektronikus kereskedelmi szabályok szerint.

## 7. Adatvédelem
7.1. A Szolgáltató az Ügyfél személyes adatait az Adatkezelési Tájékoztatóban 
foglaltak szerint kezeli, amely elérhető a Honlapon.

## 8. Egyebek
8.1. A Szolgáltató jogosult jelen ÁSZF feltételeit bármikor, egyoldalúan 
módosítani. A módosításokat a Honlapon közzéteszi.

8.2. Jelen ÁSZF-ben nem szabályozott kérdésekben a magyar jog, különösen a 
Polgári Törvénykönyv és az elektronikus kereskedelemről szóló törvény 
rendelkezései irányadóak.

Jelen ÁSZF hatálybalépésének dátuma: 2025. június 26.
`;
export default termsMd;
